import React from 'react';
import styled from '../../styled';
import * as Icons from '../icons';
import Text from '../text';
const Container = styled.div `
  position: relative;
  display: flex;
  background-color: ${({ theme }) => theme.colors.SNOW_100};
  box-shadow: 0 0.0625rem 0.1875rem 0
      ${({ theme }) => theme.colors.SHADOW_LIGHT},
    0 0 0.0625rem 0 ${({ theme }) => theme.colors.SHADOW_DEFAULT};
  padding-right: 1.5rem;

  ::after {
    content: ' ';
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    width: 1.5rem;
    background-color: ${({ theme }) => theme.colors.SNOW_100};
  }
`;
const BackLink = styled.div `
  padding: 1rem 0.75rem;
  margin-right: 0.5rem;
  line-height: 0;
  background-color: ${({ theme }) => theme.colors.INK_900};
  &:hover {
    background-color: ${({ theme }) => theme.colors.INK_800};
  }
  &:active {
    background-color: ${({ theme }) => theme.colors.INK_700};
  }
`;
const LeftItemWrapper = styled.div `
  margin: 0 0.25rem;
  display: inline-flex;
  align-items: center;
  padding: 0 0.25rem;
`;
const StyledText = styled(Text) `
  word-break: break-word;
  padding-right: 0.5rem;
`;
const RightItemWrapper = styled.div `
  display: inline-flex;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.SNOW_100};
  position: absolute;
  top: 0;
  bottom: 0;
  right: 1.5rem;
`;
const FullPageHeader = ({ title, renderRightItem, renderLeftItem, onBackLinkClick, e2eBackButtonId, }) => {
    return (React.createElement(Container, null,
        React.createElement(BackLink, { "data-e2e-id": e2eBackButtonId, onClick: onBackLinkClick },
            React.createElement(Icons.Outline.Arrow, { color: "INK_400", size: "LARGE", position: "LEFT" })),
        React.createElement(LeftItemWrapper, null,
            title && (React.createElement(StyledText, { fontType: "Body", lang: "en", color: "INK_800", weight: "Semibold" }, title)),
            renderLeftItem && renderLeftItem()),
        renderRightItem && (React.createElement(RightItemWrapper, null, renderRightItem()))));
};
export default FullPageHeader;
//# sourceMappingURL=index.js.map